// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1LEoM","name":"Header_name__1Df07","birthday":"Header_birthday__Dq0Tw","skeleton":"Header_skeleton__2JRAy"};